/**
 * D114.7: which form fields did the server refuse? The one reader of the field
 * facts `apiClient.handleResponse` hangs on a thrown error:
 *  - `validationErrors`, from an `errors` ARRAY: [{field,message}] (vendors,
 *    clients, users) or express-validator's [{path,msg}];
 *  - `details`, from an `errors` OBJECT keyed by field ({name: 'is required'},
 *    the catalogue item controller, `uom.level1Name` on item groups).
 * It never reads `err.message`: this used to JSON.parse the message, which has
 * been plain text since apiClient started unwrapping the envelope, so no field
 * was ever highlighted. A refusal with no field facts (a 409 duplicate, a 500)
 * returns {} and stays a form-level message.
 */
export function fieldErrorsOf(err: unknown): Record<string, string> {
  const out: Record<string, string> = {};
  if (!err || typeof err !== 'object') return out;
  const { validationErrors, details } = err as { validationErrors?: unknown; details?: unknown };

  if (Array.isArray(validationErrors)) {
    for (const e of validationErrors) {
      const field = e?.field ?? e?.path;
      const message = e?.message ?? e?.msg;
      if (typeof field === 'string' && field && typeof message === 'string' && message) out[field] = message;
    }
  } else if (details && typeof details === 'object') {
    for (const [field, message] of Object.entries(details as Record<string, unknown>)) {
      if (typeof message === 'string' && message) out[field] = message;
    }
  }
  return out;
}
